mutation CreateSecondFactor {
  createSecondFactor(input: {}) {
    id
    twoFactorUrl
    twoFactorCode
  }
}
